import React, {FC, ReactNode} from "react"

import {Label} from "@irati/ui/src/Typography"

export interface HeaderProps {
  renderProps: {
    HeaderLabel: ReactNode,
    showText: string,
    hideText: string,
    isExpanded: boolean
  }
}

const DefaultHeader: FC<HeaderProps> = ({renderProps: {HeaderLabel = Label, showText, hideText, isExpanded}}) => {
  return <HeaderLabel>{isExpanded ? hideText : showText}</HeaderLabel>
}

export default DefaultHeader
